var React = require('react');

function En (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#00247d","d":"M0 0h300v300H0z","key":0}),React.createElement("path",{"d":"M0 0l300 300m0-300L0 300","stroke":"#fff","strokeWidth":"60","key":1}),React.createElement("path",{"d":"M0 0l300 300m0-300L0 300","stroke":"#cf142b","strokeWidth":"40","key":2}),React.createElement("path",{"d":"M150 150v-30L30 0H0zh30L300 30V0zv30l120 120h30zh-30L0 270v30z","fill":"#fff","key":3}),React.createElement("path",{"d":"M150 0v300M0 150h300","stroke":"#fff","strokeWidth":"100","key":4}),React.createElement("path",{"d":"M150 0v300M0 150h300","stroke":"#cf142b","strokeWidth":"60","key":5})]);
}

En.defaultProps = {"viewBox":"0 0 300 300"};

module.exports = En;

En.default = En;
